import { useSearchParams } from "react-router";
import ErrorComponentPage from "./ErrorComponentPage";

const ErrorComponentSearchParams = () => { 
  const [searchParams, _setSearchParams] = useSearchParams();

  return <ErrorComponentPage status={Number(searchParams.get("code")!)} />
}

export default ErrorComponentSearchParams;